import { Tag } from '@phosphor-icons/react';

interface FilteredItemProps {
  title: string;
  isOpen: boolean;
  content: string;
  onClick: () => void;
}

const FilteredItem = ({ title, onClick }: FilteredItemProps) => {
  return (
    <div className="cursor-pointerp flex w-full items-center justify-between rounded-xl bg-white text-[0.9rem] font-semibold text-primary-700 transition-colors hover:bg-primary-100 md:pe-2">
      <div
        onClick={onClick}
        className="flex w-full items-center gap-12 py-2 md:px-4"
      >
        {title}
      </div>
      <div>
        <Tag
          size={22}
          className="text-gray-400 transition-transform hover:-translate-y-[0.15rem] hover:text-primary-700"
        />
      </div>
    </div>
  );
};

export default FilteredItem;
